// import React, { useEffect, useRef } from 'react';
// import Highcharts from 'highcharts';
// import HighchartsReact from 'highcharts-react-official';
// import { Paper, makeStyles } from '@material-ui/core';
// import exporting from 'highcharts/modules/exporting';

// // Initialize the exporting module
// exporting(Highcharts);

// const useStyles = makeStyles((theme) => ({
//     paper: {
//         padding: theme.spacing(2),
//         textAlign: 'center',
//         color: theme.palette.text.secondary,
//     },
// }));

// const StackedColumnChart = ({ data, isEvent = false }) => {
//     const classes = useStyles();
//     const chartRef = useRef(null);

//     const handleButtonLayout = (chart) => {
//         if (isEvent) {
//             const isMobile = window.innerWidth < 768;

//             // Clear existing buttons to avoid duplicates
//             if (chart.customButtons) {
//                 chart.customButtons.forEach((button) => button.destroy());
//                 chart.customButtons = [];
//             }

//             chart.customButtons = []; // Reset custom buttons array

//             // Default X offset from the right edge
//             const chartWidth = chart.chartWidth;
//             const buttonRightOffset = 10;

//             if (isMobile) {
//                 // Column layout for mobile
//                 const buttonXOffset = chartWidth - 100 - buttonRightOffset;
//                 const buttonYOffset = 40;

//                 chart.customButtons.push(
//                     chart.renderer
//                         .button('Top 10', buttonXOffset, buttonYOffset, function () {
//                             chart.xAxis[0].setExtremes(0, 9);
//                         })
//                         .add()
//                 );
//                 chart.customButtons.push(
//                     chart.renderer
//                         .button('Top 50', buttonXOffset, buttonYOffset + 40, function () {
//                             chart.xAxis[0].setExtremes(0, 49);
//                         })
//                         .add()
//                 );
//                 chart.customButtons.push(
//                     chart.renderer
//                         .button('Show All', buttonXOffset, buttonYOffset + 80, function () {
//                             chart.xAxis[0].setExtremes(null, null);
//                         })
//                         .add()
//                 );
//             } else {
//                 // Row layout for larger screens
//                 const buttonXOffset = chartWidth - 300 - buttonRightOffset;
//                 const buttonYOffset = 10;

//                 chart.customButtons.push(
//                     chart.renderer
//                         .button('Top 10', buttonXOffset, buttonYOffset, function () {
//                             chart.xAxis[0].setExtremes(0, 9);
//                         })
//                         .add()
//                 );
//                 chart.customButtons.push(
//                     chart.renderer
//                         .button('Top 50', buttonXOffset + 70, buttonYOffset, function () {
//                             chart.xAxis[0].setExtremes(0, 49);
//                         })
//                         .add()
//                 );
//                 chart.customButtons.push(
//                     chart.renderer
//                         .button('Show All', buttonXOffset + 140, buttonYOffset, function () {
//                             chart.xAxis[0].setExtremes(null, null);
//                         })
//                         .add()
//                 );
//             }
//         }
//     };

//     useEffect(() => {
//         const chart = chartRef?.current?.chart;

//         if (chart) {
//             handleButtonLayout(chart);
//         }

//         const handleResize = () => {
//             if (chart) {
//                 chart.redraw(); // Redraw the chart to handle size changes
//                 handleButtonLayout(chart);
//             }
//         };

//         window.addEventListener('resize', handleResize);

//         return () => {
//             window.removeEventListener('resize', handleResize);
//         };
//     }, [isEvent]);

//     const options = {
//         chart: {
//             type: 'column',
//             zoomType: 'x',
//             events: {
//                 load: function () {
//                     const chart = this;
//                     // Initial button layout setup
//                     handleButtonLayout(chart);
//                 },
//             },
//         },
//         title: {
//             text: data.title,
//         },
//         xAxis: {
//             categories: data.categories,
//         },
//         yAxis: {
//             min: 0,
//             title: {
//                 text: data.yAxis,
//             },
//             stackLabels: {
//                 enabled: true,
//                 style: {
//                     fontWeight: 'bold',
//                     color: 'black',
//                 },
//             },
//             labels: {
//                 formatter: function () {
//                     return Highcharts.numberFormat(this.value, 0);
//                 },
//             },
//         },
//         legend: {
//             enabled: false,
//         },
//         tooltip: {
//             headerFormat: '<b>{point.x}</b><br/>',
//             pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
//         },
//         plotOptions: {
//             column: {
//                 stacking: 'normal',
//             },
//         },
//         series: data.series,
//         exporting: {
//             enabled: true,
//         },
//         credits: {
//             enabled: false,
//         },
//     };

//     return (
//         <Paper className={classes.paper}>
//             <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
//         </Paper>
//     );
// };

// export default StackedColumnChart;



import React from 'react';
import Highcharts from 'highcharts';
// import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { Paper, makeStyles } from '@material-ui/core';
import exporting from 'highcharts/modules/exporting';

// Initialize the exporting module
exporting(Highcharts);

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));


const StackedColumnChart = ({ data, isEvent = false }) => {
    const classes = useStyles();


    const options = {
        chart: {
            type: 'column',
            zoomType: 'x',
            // events: {
            //     load: function () {
            //         const chart = this;

            //         if (isEvent) {

            //             // Set default view to show top 10 categories on initial load
            //             chart.xAxis[0].setExtremes(0, 9);

            //             // Add custom button for "Top 10"
            //             chart.renderer.button('Top 10', 80, 10, function () {
            //                 chart.xAxis[0].setExtremes(0, 9); // Set zoom to show first 10 categories
            //             }).add();

            //             // Add custom button for "Top 50"
            //             chart.renderer.button('Top 50', 150, 10, function () {
            //                 chart.xAxis[0].setExtremes(0, 49); // Set zoom to show first 50 categories
            //             }).add();

            //             // Add custom button for "Show All"
            //             chart.renderer.button('Show All', 220, 10, function () {
            //                 chart.xAxis[0].setExtremes(null, null); // Reset zoom to show all categories
            //             }).add();
            //         }
            //     }
            // }
            // events: {
            //     load: function () {
            //         const chart = this;

            //         if (isEvent) {
            //             // Adjust button positions for mobile view
            //             const isMobile = window.innerWidth < 768; // Define mobile breakpoint
            //             const buttonYOffset = isMobile ? 32 : 10; // Adjust vertical offset
            //             const buttonXOffset = isMobile ? 65 : 80; // Adjust horizontal spacing for mobile

            //             // Set default view to show top 10 categories on initial load
            //             chart.xAxis[0].setExtremes(0, 9);

            //             // Add custom button for "Top 10"
            //             chart.renderer
            //                 .button('Top 10', buttonXOffset, buttonYOffset, function () {
            //                     chart.xAxis[0].setExtremes(0, 9); // Set zoom to show first 10 categories
            //                 })
            //                 .add();

            //             // Add custom button for "Top 50"
            //             chart.renderer
            //                 .button('Top 50', buttonXOffset + 70, buttonYOffset, function () {
            //                     chart.xAxis[0].setExtremes(0, 49); // Set zoom to show first 50 categories
            //                 })
            //                 .add();

            //             // Add custom button for "Show All"
            //             chart.renderer
            //                 .button('Show All', buttonXOffset + 140, buttonYOffset, function () {
            //                     chart.xAxis[0].setExtremes(null, null); // Reset zoom to show all categories
            //                 })
            //                 .add();
            //         }
            //     }
            // }
            events: {
                load: function () {
                    const chart = this;

                    if (isEvent) {
                        const isMobile = window.innerWidth < 768;

                        // Set default view to show top 10 categories on initial load
                        chart.xAxis[0].setExtremes(0, 9);

                        // Get the chart's width to calculate the right alignment
                        const chartWidth = chart.chartWidth;

                        // Default X offset from the right edge
                        const buttonRightOffset = 10; // Space from the right edge

                        if (isMobile) {
                            // Column layout for mobile
                            const buttonXOffset = chartWidth - 100 - buttonRightOffset; // Adjust for button width and right alignment
                            const buttonYOffset = 40; // Initial vertical offset

                            // Add custom button for "Top 10"
                            chart.renderer
                                .button('Top 10', buttonXOffset, buttonYOffset, function () {
                                    chart.xAxis[0].setExtremes(0, 9);
                                })
                                .add();

                            // Add custom button for "Top 50"
                            chart.renderer
                                .button('Top 50', buttonXOffset, buttonYOffset + 40, function () {
                                    chart.xAxis[0].setExtremes(0, 49);
                                })
                                .add();

                            // Add custom button for "Show All"
                            chart.renderer
                                .button('Show All', buttonXOffset, buttonYOffset + 80, function () {
                                    chart.xAxis[0].setExtremes(null, null);
                                })
                                .add();
                        } else {
                            // Row layout for larger screens
                            const buttonXOffset = chartWidth - 300 - buttonRightOffset; // Adjust for combined button width and right alignment
                            const buttonYOffset = 10; // Vertical offset for row layout

                            // Add custom button for "Top 10"
                            chart.renderer
                                .button('Top 10', buttonXOffset, buttonYOffset, function () {
                                    chart.xAxis[0].setExtremes(0, 9);
                                })
                                .add();

                            // Add custom button for "Top 50"
                            chart.renderer
                                .button('Top 50', buttonXOffset + 70, buttonYOffset, function () {
                                    chart.xAxis[0].setExtremes(0, 49);
                                })
                                .add();

                            // Add custom button for "Show All"
                            chart.renderer
                                .button('Show All', buttonXOffset + 140, buttonYOffset, function () {
                                    chart.xAxis[0].setExtremes(null, null);
                                })
                                .add();
                        }
                    }
                }
            }

        },
        title: {
            text: data?.title || "NA"
        },
        xAxis: {
            categories: data?.categories,
            // min: 0, // Initial zoom start position
            // max: 9,

            // labels: {
            //     style: {
            //         textOverflow: 'none',
            //         whitespace:'nowrap'
            //     }
            // }
        },
        yAxis: {
            min: 0,
            title: {
                text: data?.yAxis
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                    color: 'black'
                }
            },
            labels: {
                formatter: function () {
                    return Highcharts.numberFormat(this.value, 0); // Shows full number format (1000, 2000, etc.)
                }
            }
        },
        // legend: {
        //     align: 'right',
        //     x: -10,
        //     verticalAlign: 'top',
        //     y: 25,
        //     floating: true,
        //     backgroundColor: 'white',
        //     borderColor: '#CCC',
        //     borderWidth: 1,
        //     shadow: false
        // },
        legend: {
            enabled: false, // This will hide the legend (series labels)
        },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
            column: {
                stacking: 'normal'
            }
        },
        // series: sortedSeries
        series: data?.series,

        navigator: {
            enabled: false // Disable the navigator (scroller below the x-axis)
        },
        scrollbar: {
            enabled: false // Disable the scrollbar
        },

        // rangeSelector: {
        //     selected: 0,
        //     inputEnabled: false,
        //     buttons: [{
        //         type: 'all',
        //         text: 'All',
        //         events: {
        //             click: function () {
        //                 setDataLimit(data.categories.length); // Show all vendors
        //             }
        //         }
        //     }, {
        //         type: 'Top10',
        //         text: 'Top 10',
        //         events: {
        //             click: function () {
        //                 setDataLimit(10); // Limit to 10 vendors
        //             }
        //         }
        //     }, {
        //         type: 'Top50',
        //         text: 'Top 50',
        //         events: {
        //             click: function () {
        //                 setDataLimit(50); // Limit to 50 vendors
        //             }
        //         }
        //     }]
        // }

        // Enable exporting feature
        exporting: {
            enabled: true,
            buttons: {
                contextButton: {
                    menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
                }
            }
        },
        credits: {
            enabled: false
        },

    };

    return (
        <Paper className={classes.paper}>
            {/* <HighchartsReact highcharts={Highcharts} constructorType={'stockChart'} options={options} /> */}
            <HighchartsReact highcharts={Highcharts} options={options} />
        </Paper>
    );
};

export default StackedColumnChart;
